module.exports = __webpack_public_path__ + "static/media/22.b45c1c14.jpg";